// extracted by mini-css-extract-plugin
module.exports = {"mobile":"SecurityPattern_mobile_3n5ra","desktop":"SecurityPattern_desktop_1lo-H"};